import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-pre2004jumps',
  templateUrl: './pre2004Jumps.component.html',
  styleUrls: ['./pre2004Jumps.component.scss']
})
export class Pre2004JumpsComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = false;
  modal = {
    active: false,
    data: {}
  };
  userBase;
  pre2004Jumps = [];
  headings = [
    {
      label: 'Jumper',
      key: 'jumperName'
    },
    {
      label: 'Fire',
      key: 'fire'
    },
    {
      label: 'Proficiency',
      key: 'proficiency'
    },
    {
      label: 'Ground',
      key: 'ground'
    },
    {
      label: 'Single Resource',
      key: 'single'
    },
    {
      label: 'Rescue',
      key: 'rescue'
    },
    {
      label: 'Other',
      key: 'other'
    }
  ];

  settings = {
    noCreate: true,
    route: 'pre2004jumps'
  };

  constructor(private toast: ToastService) {}

  async ngOnInit() {
    this.userBase = this.userInfo.basecode;
    this.refreshPre2004Jumps();
  }

  refreshPre2004Jumps = async () => {
    this.loading = true;
    let pre2004JumpsData = await axios.get(environment.API_URL + '/jumpers/getjumperpre2004jumpsdata?jumperId=0', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.pre2004Jumps = pre2004JumpsData.data;
    this.loading = false;
  };


}
